import { useEffect, useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { api } from "../lib/api";
import { Header } from "../components/Header";
import { Footer } from "../components/Footer";
import { advSetToken } from "./AdvertiserLoginPage";

export default function AdvertiserSetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const nav = useNavigate();
  const [pw, setPw] = useState("");
  const [err, setErr] = useState("");
  const [notFound, setNotFound] = useState(false);

  useEffect(() => {
    document.title = "Set Password — IslandsDaily";
    api.get("/advertise/enabled").then((r) => {
      if (!r.data?.enabled) setNotFound(true);
    }).catch(() => setNotFound(true));
  }, []);

  const submit = async () => {
    setErr("");
    if (pw.length < 8) {
      setErr("Password must be at least 8 characters.");
      return;
    }
    try {
      const r = await api.post("/advertiser/set-password", { token, password: pw });
      advSetToken(r.data.token);
      nav("/advertiser/dashboard");
    } catch (e) {
      setErr(e?.response?.data?.detail || "Failed to set password");
    }
  };

  if (notFound) {
    return (
      <div className="min-h-screen bg-white flex items-center justify-center" data-testid="adv-setpw-404">
        <h1 className="font-serif-display text-3xl text-[#1A2E35]">404</h1>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-white" data-testid="advertiser-set-password-page">
      <Header />
      <main className="max-w-md mx-auto py-16 px-4">
        <h1 className="font-serif-display text-[#1A2E35] text-2xl mb-2">Set Your Password</h1>
        <p className="text-[13px] text-[#6B7C82] mb-6">Create a password for your advertiser dashboard.</p>
        <div className="space-y-3">
          <input
            type="password" placeholder="new password (min 8 chars)"
            value={pw} onChange={(e) => setPw(e.target.value)}
            className="w-full border border-[#EEEEEE] rounded-lg px-3 py-2 text-sm"
            data-testid="setpw-input"
          />
          {err && <p className="text-[12px] text-[#E63946]" data-testid="setpw-error">{err}</p>}
          <button
            onClick={submit}
            className="w-full bg-[#0AADA0] text-white px-4 py-2 rounded-full text-[13px]"
            data-testid="setpw-submit"
          >Set Password</button>
        </div>
      </main>
      <Footer />
    </div>
  );
}
